export const DAMAGE_ZONES = [
  ['front_bumper','Paraurti anteriore'],['rear_bumper','Paraurti posteriore'],['hood','Cofano'],['boot','Portellone / bagagliaio'],['roof','Tetto'],
  ['windshield','Parabrezza'],['rear_window','Lunotto'],
  ...['left','right'].flatMap(side=>{
    const s=side==='left'?'sinistro':'destro',f=side==='left'?'sinistra':'destra';
    return [[`${side}_front_door`,`Portiera anteriore ${f}`],[`${side}_rear_door`,`Portiera posteriore ${f}`],
      [`${side}_front_fender`,`Parafango anteriore ${s}`],[`${side}_rear_fender`,`Parafango posteriore ${s}`],
      [`${side}_front_window`,`Vetro laterale anteriore ${s}`],[`${side}_rear_window`,`Vetro laterale posteriore ${s}`],
      [`${side}_mirror`,`Specchietto ${s}`],[`${side}_front_wheel`,`Ruota anteriore ${f}`],[`${side}_rear_wheel`,`Ruota posteriore ${f}`]];
  })
];
// These observations have no geometric panel: never map them to an exterior zone.
export const NON_MODEL_DAMAGE_ZONES = [['interior','Interni'],['other','Altra zona / non rappresentata']];
export const ALL_DAMAGE_ZONES = [...DAMAGE_ZONES,...NON_MODEL_DAMAGE_ZONES];
export const isNonModelZone=id=>NON_MODEL_DAMAGE_ZONES.some(([zone])=>zone===id);
export const DAMAGE_TYPES = [['scratch','Graffio'],['dent','Ammaccatura'],['break','Rottura'],['chip','Scheggiatura'],['stain','Macchia'],['other','Altro']];
export const zoneLabel=id=>ALL_DAMAGE_ZONES.find(z=>z[0]===id)?.[1]||'Zona non riconosciuta';
export const typeLabel=id=>DAMAGE_TYPES.find(z=>z[0]===id)?.[1]||'Tipo da indicare';
export const DAMAGE_COLORS={none:'#8299b0',delivery:'#f4b942',return:'#f07870',both:'#b29af8'};
export function damageZoneColor(state,showColors=false){
  return showColors?(DAMAGE_COLORS[state]||DAMAGE_COLORS.none):DAMAGE_COLORS.none;
}
export function zoneEvidence(zone,before,current,mode){
  const delivery=before.filter(d=>d.zone===zone).length+(mode==='consegna'?current.filter(d=>d.zone===zone).length:0);
  const returning=mode==='restituzione'?current.filter(d=>d.zone===zone).length:0;
  return {delivery,returning,state:delivery&&returning?'both':returning?'return':delivery?'delivery':'none'};
}
export function damageErrors(items){
  if(!Array.isArray(items))return ['Elenco danni non valido.'];
  if(items.length>50)return ['Puoi registrare al massimo 50 danni per operazione.'];
  const errors=[],seen=new Set();
  items.forEach((d,i)=>{
    const prefix=`Danno ${i+1}`;
    if(!d||typeof d.id!=='string'||seen.has(d.id))errors.push(`${prefix}: identificativo mancante o duplicato.`);
    seen.add(d?.id);
    if(!ALL_DAMAGE_ZONES.some(z=>z[0]===d?.zone))errors.push(`${prefix}: seleziona una zona valida.`);
    if(!DAMAGE_TYPES.some(t=>t[0]===d?.type))errors.push(`${prefix}: indica il tipo.`);
    if(typeof d?.description!=='string'||!d.description.trim()||d.description.length>2000)errors.push(`${prefix}: ${isNonModelZone(d?.zone)?'specifica la posizione e descrivi il danno':'descrivi il rilievo'} (massimo 2000 caratteri).`);
    if(!Array.isArray(d?.photos)||d.photos.length<1||d.photos.length>10)errors.push(`${prefix}: aggiungi da 1 a 10 foto.`);
  });
  return errors;
}
export function recordedDamage(a,operation){
  return (a.damage_inspections||[]).filter(r=>r.vehicle_id===a.vehicle_id&&r.operation===operation).flatMap(r=>r.items);
}
